<template>
    <div>
        <h2 class="mb-5">Checkout</h2>
        <div v-if="order_finished == false">
            <!-- IF CART HAVE ITEMS -->
            <div class="vx-row" v-if="cartItems.length">

                <!-- LEFT COL -->
                <div class="vx-col lg:w-2/3 w-full relative">
                    <div class="items-list-view" v-for="(item, index) in cartItems" :key="index">
                        <item-list-view :item="item">

                            <!-- SLOT: ITEM META -->
                            <template slot="item-meta">
                                <h6 class="item-name font-semibold mb-1">{{ item.measure ? item.name + ' - ' + item.measure : item.name }}</h6>
                                <p class="item-description truncate text-sm">{{ item.description }}</p>

                                <p class="mt-4 font-bold text-sm">{{ $t('quantity') }}</p>
                                <div class="flex mt-2">
                                    <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-minus" v-on:click="minus(index)"></vs-button>
                                    <vs-button color="dark" type="border">{{ item.quantity }}</vs-button>
                                    <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus" v-on:click="plus(index)"></vs-button>
                                </div> 
                            </template>

                            <!-- SLOT: ACTION BUTTONS -->
                            <template slot="action-buttons">

                                <!-- PRIMARY BUTTON: REMOVE -->
                                <vs-button class="w-full p-3 mb-3" color="danger" type="filled" @click="removeItemFromCart(item)">
                                    <span class="text-sm font-semibold ml-2">REMOVER</span>
                                </vs-button>

                            </template>
                        </item-list-view>
                    </div>
                </div>

                <!-- RIGHT COL -->
                <div class="vx-col lg:w-1/3 w-full">
                    <vx-card>
                        <div class="flex justify-between font-semibold mb-2">
                            <span>{{ $t('notes') }}</span>
                        </div>

                        <vs-textarea counter="120" label="" :counter-danger.sync="counterDanger" v-model="details" />
                    </vx-card>
                    <br>
                    <vx-card>
                        <div class="flex justify-between font-semibold mb-3">
                            <span>Total</span>
                            <span>{{ cartItems[0].currency + ' ' + calcTotal(cartItems) }}</span>
                        </div>

                        <vs-button class="w-full" v-on:click="placeOrdwer()">{{ $t('finishOrder') }}</vs-button>
                    </vx-card>
                </div>
            </div>

            <!-- IF NO ITEMS IN CART -->
            <vx-card v-else>
                <p class="mb-3">{{ $t('noItemsInCart') }}</p>
                <vs-button @click="$router.push('/geral/menus')">{{ $t('seeMenus') }}</vs-button>
            </vx-card>
        </div>
    </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
const ItemListView = () => import('./components/ItemListView.vue')

export default {
    data() {
        return {
            details: '',
            counterDanger: false,
            order_finished: false
        }
    },
    computed: {
        cartItems() {
            return this.$store.state.eCommerce.cartItems;
        },
        isInWishList() {
            return (itemId) => this.$store.getters['eCommerce/isInWishList'](itemId)
        },
    },
    methods: {
        removeItemFromCart(item) {
            this.$store.dispatch('eCommerce/toggleItemInCart', item)
        },

        updateItemQuantity(event, index) {
            const itemIndex = Math.abs(index + 1 - this.cartItems.length)
            this.$store.dispatch("eCommerce/updateItemQuantity", { quantity: event, index: itemIndex })
        },

        minus(index) {
            if (this.cartItems[index].quantity > 1) {                
                let quantity = this.cartItems[index].quantity - 1;
                let price = parseFloat(parseFloat(this.cartItems[index].price) - parseFloat(this.cartItems[index].base_price)).toFixed(2)
                this.$store.dispatch("eCommerce/updateItemQuantity", {  quantity: quantity, price: price, index: index })
            }
        },

        plus(index) {
            let quantity = this.cartItems[index].quantity + 1;
            let price = parseFloat(parseFloat(this.cartItems[index].price) + parseFloat(this.cartItems[index].base_price)).toFixed(2)
            this.$store.dispatch("eCommerce/updateItemQuantity", { quantity: quantity, price: price, index: index })
        },

        calcTotal(cartItems) {
            let total = 0;

            cartItems.forEach(x => {
                total += parseFloat(x.price);
            });

            return total;
        },

        placeOrdwer() {
            this.$vs.loading();
            let user = JSON.parse(localStorage.getItem('userSession'));

            let order = {
                clientId: user.id,
                hotelId: user.hotel.hotel_id,
                name: user.name,
                email: user.email,
                reservationId: user.hotel.num_reserva,
                roomId: user.hotel.room_number,
                hotelName: user.hotel.hotel_name,
                details: this.details.length > 0 ? this.details : '---',
                items: this.cartItems,
            }

            let that = this;

            this.$api.post( '/myvilagale/hotel/' + order.hotelId + '/orders?token=' + localStorage.getItem('usertoken'),
            order,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('usertoken')
                }

            }).then(function(res) {
                that.$vs.loading.close();
                that.$vs.notify({
                    time: '4000',
                    text: that.$t('order_placed'),
                    color:'success',
                    position:'bottom-right',
                    iconPack: 'feather',
                    icon:'icon-check'
                });
                that.$store.dispatch('eCommerce/clearCart');
                that.$router.push('/eCommerce/orders');

            })
            .catch(function(err) {
                that.$vs.loading.close();
                that.$vs.notify({
                    text: that.$t('order_error'),
                    color:'danger',
                    position:'bottom-right',
                    iconPack: 'feather',
                    icon:'icon-alert-triangle'
                });
            });                    
        }
    },
    components: {
        ItemListView,
        FormWizard,
        TabContent
    }
}
</script>

<style lang="scss" scoped>
#ecommerce-checkout-demo {
    .item-view-primary-action-btn {
        color: #2c2c2c !important;
        background-color: #f6f6f6;
    }

    .item-name {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        -webkit-line-clamp: 2;
    }

    .vue-form-wizard {
        /deep/ .wizard-header {
            padding: 0;
        }

        /deep/ .wizard-tab-content {
            padding-right: 0;
            padding-left: 0;
        }
    }
}
</style>
